import { getToken, getUser, getFirstName, getLastName } from "../Utils/Common";
import { postAPICall, postAPICall2 } from "./axiosMethodCalls";
import Moment from "moment";

// Check if we're in development mode and should use mock authentication
const USE_MOCK_AUTH = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCK_AUTH === 'true';

export const createTimesheet = async (data) => {
    // Use mock response if enabled
    if (USE_MOCK_AUTH) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {
                        success: true,
                        message: "Time-in recorded successfully",
                        timesheet_id: Math.floor(Math.random() * 1000) + 1,
                        timestamp: new Date().toISOString(),
                        user_id: getUser()
                    }
                });
            }, 1000); // Simulate network delay
        });
    }

    // Original API call for production
    try {
      var formData = new FormData();
      formData.append("requester", getUser())
      formData.append("token", getToken().replace(/['"]+/g, ''))
      // formData.append("address",data.address_1)
      // formData.append("address2",data.address_2)
      // formData.append("latitude",data.latitude)
      // formData.append("longitude",data.longitude)
      formData.append("photo_proof",data.photo_proof)
      // formData.append("photo_proof",data.photo_proof[0])
      const response = await postAPICall2( process.env.REACT_APP_LINK + 'timesheets/time_in', formData);
        return ({data:response.data});
    } catch (error) {
        return ({error: error.response});
    }
}

export const createTimesheetOut = async (timesheet_id) => {
    // Use mock response if enabled
    if (USE_MOCK_AUTH) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {
                        success: true,
                        message: "Time-out recorded successfully",
                        timesheet_id: timesheet_id,
                        timestamp: new Date().toISOString(),
                        user_id: getUser()
                    }
                });
            }, 1000); // Simulate network delay
        });
    }

    // Original API call for production
    try {
      var formData = new FormData();
      formData.append("requester", getUser())
      formData.append("token", getToken().replace(/['"]+/g, ''))
      formData.append("timesheet_id",timesheet_id)
      const response = await postAPICall2( process.env.REACT_APP_LINK + 'timesheets/time_out', formData);
        return ({data:response.data});
    } catch (error) {
        return ({error: error.response});
    }
}

export const searchTimesheet = async () => {
    // Use mock response if enabled
    if (USE_MOCK_AUTH) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {
                        data: [
                            {
                                id: 1,
                                user_id: getUser(),
                                time_in: Moment().format("YYYY-MM-DD HH:mm:ss"),
                                time_out: null,
                                status: "active",
                                date: Moment().format("YYYY-MM-DD")
                            }
                        ]
                    }
                });
            }, 500); // Simulate network delay
        });
    }

    // Original API call for production
    try {
      var formData = new FormData();
      formData.append("requester", getUser())
      formData.append("token", getToken().replace(/['"]+/g, ''))
    //   formData.append("timesheet_id",timesheet_id)
      const response = await postAPICall2( process.env.REACT_APP_LINK + 'timesheets/search', {
        requester:getUser(),
        token: getToken().replace(/['"]+/g, ''),
        date_from: Moment().format("YYYY-MM-DD"),
        date_to: Moment().format("YYYY-MM-DD"),
        // date_from: new Date().toLocaleDateString("en-US"),
        // date_to: new Date().toLocaleDateString("en-US"),
        type:"agent",
        agent_id:getUser()
      });
        return ({data:response.data});
    } catch (error) {
        return ({error: error.response});
    }
}

export const searchFormResponses = async () => {
  // Use mock response if enabled
  if (USE_MOCK_AUTH) {
      return new Promise((resolve) => {
          setTimeout(() => {
              resolve({
                  data: {
                      data: [
                          {
                              id: 1,
                              merchant: "Sample Merchant 1",
                              outlet: "Main Branch",
                              date_created: Moment().format("YYYY-MM-DD"),
                              status: "completed"
                          },
                          {
                              id: 2,
                              merchant: "Sample Merchant 2",
                              outlet: "Branch 2",
                              date_created: Moment().subtract(1, 'day').format("YYYY-MM-DD"),
                              status: "completed"
                          }
                      ]
                  }
              });
          }, 500); // Simulate network delay
      });
  }

  // Original API call for production 
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "forms/search",
      {
        requester: getUser(),
        token: getToken().replace(/['"]+/g, ''),
        date_from: Moment().format("YYYY-MM-DD"),
        date_to: Moment().format("YYYY-MM-DD"),
        encoded_by: `${getFirstName()} ${getLastName()}`,
        requester_only: 0, // Get all forms, not just requester's
        page: 1,
      }
    );
    return { data: response.data };
  } catch (error) {
    // Gracefully handle 404 (No forms found) by returning an empty list
    if (error?.response?.status === 404) {
      return { data: { data: [] } };
    }
    return { error: error?.response || error };
  }
};
